import {
  GET_EMP_WORKING_PROJECTS_SUCCESS,
  GET_EMP_TASK_SUCCESS,
  GET_PROJECT_ID_TASK,
  ADD_TASK_SUCCESS,
  UPDATE_TASK_SUCCESS,
  DEL_TASK_SUCCESS,
  ON_CHANGE_TASK_DATE,
  ADD_PROJECT_FROM_TASK,
  GET_ALL_TASK_OF_PROJECT_SUCCESS,
  ADD_TASK_UNLOCK_REQUEST_SUCCESS,
  GET_TASK_UNLOCK_REQUEST_SUCCESS,
  GET_Leave_REQUEST_SUCCESS,
  GET_RECANDHOLIDAY_CALENDAR_SUCCESS,
  DELETE_APPLIED_LEAVES_SUCCESS,
  UPDATE_STATUS_TASK_SUCCESS,
} from "../../actions/actionType";

const initialState = {
  fullTaskArr: [],
  empTask: [],
  taskProjectId: "",
  projectNames: [],
  tasksOfProject: [],
  taskProjectInfo: {},
  unlockRequests:[],
  temp : [],
  leaveRequest:[],
  recandholidayList: [],
  appliedleaves:[],
};

export default function (state = initialState, action) {
  switch (action.type) {
    case GET_EMP_TASK_SUCCESS:
      return {
        ...state,

        empTask: action.payload,
      };
    case GET_EMP_WORKING_PROJECTS_SUCCESS:
      let empWorkingProjectList =
        action.payload.empWorkingProjects[0].projectList;
      return {
        ...state,
        projectList: empWorkingProjectList,
        taskProjectInfo: {
          projectId: empWorkingProjectList[0]?.projectID,
          projectName: empWorkingProjectList[0]?.projectName,
          status: empWorkingProjectList[0]?.status
        },
      };
    case GET_PROJECT_ID_TASK:
      return {
        ...state,
        taskProjectInfo: {
          projectId: action.payload.projectId,
          projectName: action.payload.projectName,
          status: action.payload.status
        },
      };
    case ADD_TASK_SUCCESS:
      return {
        ...state,
        fullTaskArr: [...state.fullTaskArr, action.formData],
        empTask: [...state.empTask, action.formData],
      };
      case UPDATE_STATUS_TASK_SUCCESS:
      return {
        ...state,
        fullTaskArr: state.fullTaskArr.map((task) =>
        task.employeeTimeSheetId === action.formData.employeeTimeSheetId ? action.formData : task
      ),
      empTask: state.empTask.map((task) =>
      task.employeeTimeSheetId === action.formData.employeeTimeSheetId ? action.formData : task),
      };
    case ADD_PROJECT_FROM_TASK:
      return {
        ...state,
        projectNames: [...state.projectNames, action.payload],
      };
    case UPDATE_TASK_SUCCESS:
      return {
        ...state,
        fullTaskArr: state.fullTaskArr.map((task) =>
          task.employeeTimeSheetId === action.formData.employeeTimeSheetId ? action.formData : task
        ),
        empTask: state.empTask.map((task) =>
        task.employeeTimeSheetId === action.formData.employeeTimeSheetId ? action.formData : task
      ),
      };
    case DEL_TASK_SUCCESS:
      return {
        ...state,
        fullTaskArr: state.fullTaskArr.filter(
          (task) => task.employeeTimeSheetId !== action.payload
        ),
        empTask: state.empTask.filter((task) => task.employeeTimeSheetId !== action.payload),
      };
    case GET_ALL_TASK_OF_PROJECT_SUCCESS: {
      return {
        ...state,
        tasksOfProject: action.payload,
      };
    }
    case GET_TASK_UNLOCK_REQUEST_SUCCESS:
      return {
        ...state,
        unlockRequests: action.payload,
      };

      case GET_Leave_REQUEST_SUCCESS:
      return {
        ...state,
        leaveRequest: action.payload,
      };
    case ADD_TASK_UNLOCK_REQUEST_SUCCESS:
      return {
        ...state,
        unlockRequests: state.unlockRequests.map((el) =>
          el.unlockRequestId === action.formData.unlockRequestId
            ? {
                ...el,
                unlockRequests: [action.formData],
              }
            : el
        ),
      }; 
       //----Recursive and Holiday Calendar---//
 case GET_RECANDHOLIDAY_CALENDAR_SUCCESS:
  return {
    ...state,
    recandholidayList: action.payload,
  };  
  
  case DELETE_APPLIED_LEAVES_SUCCESS:
    return {
      ...state,
      appliedleaves: action.payload,
    };
  
    default:
      return state;
  }
}
